import { DumpEvent, DumpEventFilters } from "../../../models/DumpEvent";
import { TriplePPagination } from "../TriplePInterface";

export const getDumpEvent = (data: any): DumpEvent => {
  const a = data.attributes;
  return {
    id: data.id,
    dumpYardId: a.dump_yard_id ?? null,
    orderId: a.order_id != null ? a.order_id : null,
    driverId: a.driver_id != null ? a.driver_id : null,
    receiptS3Location: a.receipt_s3_location || "",
    receiptSource: a.receipt_source,
    paidAmount: a.paid_amount != null ? Number(a.paid_amount) : null,
    weight: a.weight != null ? Number(a.weight) : null,
    vendorTicketNumber: a.vendor_ticket_number || "",
    extractionStatus: a.extraction_status,
    extractionConfidence:
      a.extraction_confidence != null ? Number(a.extraction_confidence) : null,
    createdAt: a.created_at,
    orderName: a.order_name || "",
    orderAddress: a.order_address || "",
    orderCity: a.order_city || "",
    orderZip: a.order_zip || "",
    orderDumpsterSize: a.order_dumpster_size || "",
    orderBasePrice: a.order_base_price != null ? Number(a.order_base_price) : 0,
    driverName: a.driver_name || "",
    dumpYardName: a.dump_yard_name || "",
  };
};

export const getDumpEvents = (data: any): DumpEvent[] => {
  return data.map(getDumpEvent);
};

// The backend GET /dump_events applies only the WHERE filters below and
// ORDER BY created_at DESC — it has no LIMIT/OFFSET, so `pagination` is
// optional and omitted by the receipts table (it renders the full set).
export const buildDumpEventParams = (
  filters: DumpEventFilters,
  pagination?: TriplePPagination
): URLSearchParams => {
  const params = new URLSearchParams();
  if (pagination) {
    params.append("count", pagination.count + "");
    params.append("offset", pagination.offset + "");
  }

  if (filters.startDate) {
    params.append("start", filters.startDate.toISOString());
  }
  if (filters.endDate) {
    params.append("end", filters.endDate.toISOString());
  }
  if (filters.status && filters.status.length > 0) {
    filters.status.forEach((s) => params.append("extraction_status", s));
  }
  if (filters.dumpYardId) {
    params.append("dump_yard_id", filters.dumpYardId);
  }
  if (filters.orderId) {
    params.append("order_id", filters.orderId);
  }
  if (filters.driverId) {
    params.append("driver_id", filters.driverId);
  }
  if (filters.dumpYardTemplateId) {
    params.append("dump_yard_template_id", filters.dumpYardTemplateId);
  }

  return params;
};
